<template>
  <div class="mgt-20px">
    <div class="card">
      <header class="header-card">
        <p>{{ $t('commentaire.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p class="has-text-default has-text-weight-bold">
              {{ $t('commentaire.title')}}
            </p>
            <div class="columns is-multiline">
              <div class="column is-12">
                <b-input class="mgt-10px" type="textarea"
                  rows="6"
                  v-model="demandeImpression.commentaire">
                </b-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
};
</script>
